import { render, staticRenderFns } from "./buygoods.vue?vue&type=template&id=cf355d72&scoped=true"
import script from "./buygoods.vue?vue&type=script&lang=js"
export * from "./buygoods.vue?vue&type=script&lang=js"
import style0 from "./buygoods.vue?vue&type=style&index=0&id=cf355d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf355d72",
  null
  
)

export default component.exports